import {Checkbox} from "primereact/checkbox";

import ParameterFieldContainer from "./ParameterFieldContainer";
import {getResourceColor, useInputParameterDef} from "./paramHooks";

export default function ParameterInputCheckbox({
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    doForward,
    setNullOrEmpty,
}) {
    const parameterData = useInputParameterDef(parameter, parameter_details_def);

    return (
        <ParameterFieldContainer
            layout="checkbox"
            id={id}
            label={label}
            parameter={parameter}
            parameterType={parameterType}
            parameter_details_def={parameter_details_def}
            required={parameterData.required}
            showUnit={false}
            showDescription={false}
            onResetOrEmpty={setNullOrEmpty ?? null}
            hasAssociatedOutputParam={false}
            eventToValueMapper={(checked) => ({value: checked === true})}
            renderControl={({className, onChange, value, activeParameterType, disabled, hasError}) => {
                const color = getResourceColor(activeParameterType, false, activeParameterType === "immodrop");
                return (
                    <Checkbox
                        inputId={id}
                        checked={value}
                        onChange={(e) => (!doForward ? onChange(e.checked || null) : null)}
                        invalid={hasError}
                        disabled={disabled}
                        className={`${className} ${parameter}`}
                        data-pr-position="top"
                        pt={{box: {className: `border-${color} bg-${value === true ? color : ""}`}}}
                        onClick={doForward ?? null}
                    />
                );
            }}
        />
    );
}
